<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("state", 2) }}</div>
      <div>
        <router-link
          v-if="$can('update', 'States')"
          class="btn-blue"
          @click.native="goToRoute('/master/edit-state')"
          to
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="states"
          >{{ $tc("state", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div
            v-for="(item, index) in States"
            :key="index"
            class="col-md-12 py-2"
          >
            <span v-if="login_user_role_id === 1">
              <div
                class="row border-bottom"
                v-if="
                  item.fieldname == 'created_at' && GetRoleId && GetRoleId === 1
                "
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="
                  item.fieldname == 'created_by' && GetRoleId && GetRoleId === 1
                "
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="
                  item.fieldname == 'updated_at' && GetRoleId && GetRoleId === 1
                "
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="
                  item.fieldname == 'updated_by' && GetRoleId && GetRoleId === 1
                "
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
            </span>
            <div
              class="row border-bottom"
              v-if="
                item.fieldname !== 'state_id' &&
                item.fieldname !== 'created_at' &&
                item.fieldname !== 'created_by' &&
                item.fieldname !== 'updated_by' &&
                item.fieldname !== 'updated_at'
              "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import States from "@/helper/formJSONMaster/States";

export default {
  data() {
    return {
      login_user_role_id: null,
      tableId: null,
      States: [
        ...States.ms_states,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: "123456",
          type: "number",
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: true,
          type: "date",
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: true,
          type: "number",
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: true,
          type: "date",
        },
      ],

      Methods: States.Methods,
      submitted: false,
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.tableId = id;
      this.getViewList(id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId,
        },
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getViewList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.States.map((x, index) => {
              if (x.fieldname === "created_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "States");
              } else if (x.fieldname === "updated_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "States");
              } else if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
              } else if (x.type === "date") {
                x.fieldvalue = this._formatDate_dd_mm_yyyy(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
                this.getCountryList(obj[x.fieldname], index);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCountryList: function (value, index) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let array = data.Records.filter((x) => x.country_id === value);
            if (value && index && array.length > 0) {
              this.States[index].fieldvalue = array[0].country_name;
            }
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getViewUsersDetails(user_id, index, key) {
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/StatesComponents/viewState.vue